// extracted by mini-css-extract-plugin
export default {"heading-5":"SJi6K a8cCT","heading5":"SJi6K a8cCT","background-color":"#F2F2F2","backgroundColor":"#F2F2F2","heading":"p_C1R SJi6K a8cCT","productSizes":"mD1YC","size":"TIZaL"};